import instance from "@/services/api";

export const documentQueueAPI = {
  async read(params) {
    return await instance(true, null, { showToast: false, throwError: true })
      .get("/common/document_queue/read/", { params })
      .then((res) => res?.data);
  },

  async statusCounts() {
    return await instance(true, null, { showToast: false, throwError: true })
      .get("/common/document_queue/status_counts/")
      .then((res) => res?.data);
  },

  async filterOptions() {
    return await instance(true, null, { showToast: false, throwError: true })
      .get("/common/document_queue/filter_options/")
      .then((res) => res?.data);
  },

  async regenerate(data) {
    return await instance(true, null, { showToast: false, throwError: true })
      .post("/common/document_queue/regenerate/", data)
      .then((res) => res?.data);
  },

  async regenerateBulk(items) {
    return await instance(true, null, { showToast: false, throwError: true })
      .post("/common/document_queue/regenerate_bulk/", { items })
      .then((res) => res?.data);
  },

  async delete(ids) {
    return await instance(true, null, { showToast: false, throwError: true })
      .post("/common/document_queue/delete/", { ids })
      .then((res) => res?.data);
  },
};
